import { trackAddToCart } from './checkout'

const ADD_TO_CART_SELECTOR = '.add-to-cart, [name="add"], button[type="submit"]'

let installed = false

/**
 * Listener global de clics: cualquier elemento con la clase .add-to-cart,
 * con name="add" o un button[type="submit"] envía AddToCart al Meta Pixel.
 * Equivalente al snippet de Shopify, pero dentro del ciclo de vida de la app.
 */
export function installAddToCartClickTracker() {
  if (typeof document === 'undefined' || installed) return
  installed = true

  document.addEventListener(
    'click',
    (event) => {
      const target = event.target as HTMLElement | null
      if (!target?.closest?.(ADD_TO_CART_SELECTOR)) return
      trackAddToCart()
    },
    true,
  )
}
